// Route colors for climbing routes
export const RouteColors = {
  blue: 'blu',
  yellow: 'y',
  green: 'g',
  red: 'r',
  orange: 'or',
  brown: 'br',
  pink: 'pi',
  grey: 'grey',
  purple: 'pu',
  lime: 'li',
  cyan: 'cy',
  white: 'w',
  black: 'bla'
} as const;

// Available colors for UI display
export const AvailableColors = [
  { name: 'Blue', value: 'blue', hexCode: '#2563eb' },
  { name: 'Yellow', value: 'yellow', hexCode: '#fcfc17' },
  { name: 'Green', value: 'green', hexCode: '#16a34a' },
  { name: 'Red', value: 'red', hexCode: '#dc2626' },
  { name: 'Orange', value: 'orange', hexCode: '#ea580c' },
  { name: 'Brown', value: 'brown', hexCode: '#92400e' },
  { name: 'Pink', value: 'pink', hexCode: '#ec4899' },
  { name: 'Grey', value: 'grey', hexCode: '#9ca3af' },
  { name: 'Purple', value: 'purple', hexCode: '#8b5cf6' },
  { name: 'Lime', value: 'lime', hexCode: '#84cc16' },
  { name: 'Cyan', value: 'cyan', hexCode: '#06b6d4' },
  { name: 'White', value: 'white', hexCode: '#ffffff' },
  { name: 'Black', value: 'black', hexCode: '#000000' },
];
